export const createRoleForRegister = (role: string | undefined) => {
  switch (role) {
    case 'Зал':
      return 'employeePlace'
    case 'зал':
      return 'employeePlace'
    case 'Агент':
      return 'employeeAgent'
    case 'агент':
      return 'employeeAgent'
    case 'Суперадминистратор':
      return 'superAdmin'
    case 'суперадминистратор':
      return 'superAdmin'
    case 'Администратор':
      return 'admin'
    case 'администратор':
      return 'admin'
    case 'Директор-Агент':
      return 'directorAgent'
    case 'директор-агент':
      return 'directorAgent'
    case 'директор-Агент':
      return 'directorAgent'
    case 'Директор-агент':
      return 'directorAgent'
    case 'Директор-Зал':
      return 'directorPlace'
    case 'директор-зал':
      return 'directorPlace'
    case 'Директор-зал':
      return 'directorPlace'
    case 'директор-Зал':
      return 'directorPlace'
  }
}

export const createRoleForTable = (roleEN: string | undefined) => {
  switch (roleEN) {
    case 'superAdmin':
      return 'Суперадминистратор'
    case 'admin':
      return 'Администратор'
    case 'directorAgent':
      return 'Директор-Агент'
    case 'directorPlace':
      return 'Директор-Зал'
    case 'employeeAgent':
      return 'Агент'
    case 'employeePlace':
      return 'Зал'
  }
}

export const createRoleCompanyFromRuToEn = (role: string) => {
  switch (role) {
    case 'Зал':
      return 'directorPlace'
    case 'Агент':
      return 'directorAgent'
  }
}

export const createRoleCompanyFromEnToRu = (roleEN: string | undefined) => {
  switch (roleEN) {
    case 'directorAgent':
      return 'Агент'
    case 'directorPlace':
      return 'Зал'
  }
}

export const createStatusForRegistrationRequest = (status: string | undefined) => {
  switch (status) {
    case 'inProgress':
      return 'В ожидании'
    case 'accepted':
      return 'Принят'
    case 'rejected':
      return 'Отклонен'
  }
}

export const createStatusForRegistrationRequestFilters = (status: string | undefined) => {
  switch (status) {
    case 'inProgress':
      return 'В ожидании'
    case 'accepted':
      return 'Приняты'
    case 'rejected':
      return 'Отклонены'
    case 'directorPlace':
      return 'Директор-Зал'
    case 'directorAgent':
      return 'Директор-Агент'
    case 'employeePlace':
      return 'Зал'
    case 'employeeAgent':
      return 'Агент'
    case 'admin':
      return 'Администратор'
    case 'superAdmin':
      return 'Суперадминистратор'
    default:
      return 'Все'
  }
}

export const createStatusForCompanyFilters = (status: string | undefined) => {
  switch (status) {
    case 'directorPlace':
      return 'Зал'
    case 'directorAgent':
      return 'Агент'
    case 'inProgress':
      return 'В работе'
    case 'accepted':
      return 'Завершенные'
    case 'rejected':
      return 'Отклонены'
    default:
      return 'Все'
  }
}
